// Add active class to search form
const searchBtn = document.querySelector('.search-btn');
const searchForm = document.querySelector('#quick_search_mobile');

if (searchBtn !== null) {
    searchBtn.addEventListener('click', () => {
        searchForm.classList.toggle('active');
    });
}


// Remove active class from search form
const closeSearch = document.querySelector('.close-search');

if (closeSearch !== null) {
    closeSearch.addEventListener('click', () => {
        searchForm.classList.remove('active');
    });
}